import { rootApi } from '../rootApi';

export const invoiceApprovalApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getInvoiceApprovals: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);

                const dealers = params.dealerList || [];
                const warrTypeIds = params.warrTypeIds || [];
                const isAllDealers = !!params.isAllDealers;
                const isAllWarrTypes = !!params.isAllWarrTypes;

                if (!isAllDealers && dealers.length > 0) {
                    dealers.forEach((id) => queryParams.append('DealerList', id));
                }
                queryParams.append('IsAllDealers', String(isAllDealers));

                if (!isAllWarrTypes) {
                    warrTypeIds.forEach((id) => queryParams.append('WarrTypeIds', id));
                }
                queryParams.append('IsAllWarrTypes', String(isAllWarrTypes));

                if (params.domesticType != null) {
                    queryParams.append('DomesticType', params.domesticType);
                }

                return { url: `v1/invoiceapprovalprocess/getlist?${queryParams.toString()}`, method: 'GET' };
            },
            providesTags: ['InvoiceApprovals']
        }),

        getInvoiceApprovalById: builder.query({
            query: (WarrClaimId) => ({
                url: `v1/invoiceapprovalprocess/getbyid?WarrClaimId=${WarrClaimId}`,
                method: 'GET'
            }),
            providesTags: ['InvoiceApproval']
        }),

        getInvoiceApprovalHistory: builder.query({
            query: (params) => {
                const queryParams = new URLSearchParams();
                queryParams.append('PageNumber', params.pageNumber || 1);
                queryParams.append('PageSize', params.pageSize || 10);

                if (params.bosBranchCodes?.length > 0) {
                    params.bosBranchCodes.forEach((code) => queryParams.append('BosBranchCodes', code));
                }
                if (params.startDate) queryParams.append('StartDate', params.startDate);
                if (params.endDate) queryParams.append('EndDate', params.endDate);
                if (params.warrType) queryParams.append('WarrType', params.warrType);
                if (params.chassisNo) queryParams.append('ChassisNo', params.chassisNo);
                if (params.dmsOrderNumber) queryParams.append('DmsOrderNumber', params.dmsOrderNumber);

                return { url: `v1/invoiceapprovalprocess/gethistory?${queryParams.toString()}`, method: 'GET' };
            },
            providesTags: ['InvoiceApprovalHistory']
        }),

        exportInvoiceApprovalHistory: builder.query({
            query: (data) => ({
                url: 'v1/invoiceapprovalprocess/exporthistorytoexcel',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => response?.data
        }),

        updateInvoiceApproval: builder.mutation({
            query: (data) => ({
                url: 'v1/invoiceapprovalprocess/update',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => response?.data,
            invalidatesTags: ['InvoiceApprovals', 'InvoiceApproval', 'InvoiceApprovalHistory']
        }),

        getInvoiceApprovalPreview: builder.mutation({
            query: (data) => ({
                url: 'v1/invoiceapprovalprocess/preview',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => response?.data
        })
    })
});

export const {
    useGetInvoiceApprovalsQuery,
    useLazyGetInvoiceApprovalsQuery,
    useGetInvoiceApprovalByIdQuery,
    useGetInvoiceApprovalHistoryQuery,
    useLazyGetInvoiceApprovalHistoryQuery,
    useLazyExportInvoiceApprovalHistoryQuery,
    useUpdateInvoiceApprovalMutation,
    useGetInvoiceApprovalPreviewMutation
} = invoiceApprovalApi;
